function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 1.185a1.55 1.55 0 00-.76.2l-8.25 4.64a1.55 1.55 0 00-.79 1.351v9.248a1.55 1.55 0 00.79 1.35l8.25 4.641a1.55 1.55 0 001.52 0l8.25-4.64a1.551 1.551 0 00.79-1.351V7.376a1.55 1.55 0 00-.79-1.35l-8.25-4.641a1.55 1.55 0 00-.76-.2zM4.638 6.934L12 2.793l7.374 4.148-7.289 4.141zM3.8 8.299v8.296l7.412 4.169.073-8.296zm9.012 12.451l7.388-4.155V8.312l-7.315 4.156z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgCube;